import styled from 'styled-components';

import { breakpoints, theme } from '@notino/react-styleguide';

export const HeaderWrapper = styled.div`
  padding: 1rem 0.5rem 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: ${breakpoints.md}) {
    justify-content: start;
    padding: 0 1rem;
    margin: 2rem 0;
  }
`;

export const HeaderTitle = styled.div`
  ${theme.typography.labelLarge}
  @media (min-width: ${breakpoints.md}) {
    ${theme.typography.titleLarge}
  }
`;
